import { Management } from '../DTO/management';
import { Type } from '../DTO/type';

export class FeaturesResearchFilterModel {
  constructor(
    public accountCode?: string,
    public customerCode?: string,
    public unit?: string,
    public management?: Management,
    public article?: string,
    public productAppId?: string,
    public productId?: string,
    public productType?: string,
    public type?: Type
  ) {}
}
